import { render, staticRenderFns } from "./payFailure.vue?vue&type=template&id=328919aa&scoped=true&"
import script from "./payFailure.vue?vue&type=script&lang=js&"
export * from "./payFailure.vue?vue&type=script&lang=js&"
import style0 from "./payFailure.vue?vue&type=style&index=0&id=328919aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328919aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328919aa')) {
      api.createRecord('328919aa', component.options)
    } else {
      api.reload('328919aa', component.options)
    }
    module.hot.accept("./payFailure.vue?vue&type=template&id=328919aa&scoped=true&", function () {
      api.rerender('328919aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/redirect/payFailure.vue"
export default component.exports